import { useState } from 'react';
import { getKlookSearchUrl } from '../../services/klookService';

const KlookBookingCard = ({ activity, cities = [], destination }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!activity || !['sightseeing', 'adventure'].includes(activity.category)) {
    return null;
  }

  const resolvedCities = cities.length
    ? cities
    : destination ? [destination.split(',')[0].trim()] : [];

  const klookUrl = getKlookSearchUrl(activity.title, resolvedCities);

  return (
    <div
      className="mt-4 border border-orange-200 rounded-xl overflow-hidden bg-gradient-to-r from-orange-50 to-amber-50 transition-all duration-200 hover:shadow-md"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="px-4 py-3 bg-gradient-to-r from-orange-500 to-amber-500">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-lg">🎫</span>
            <span className="text-white font-semibold text-sm">Book This Experience</span>
          </div>
          <img
            src="https://res.klook.com/image/upload/v1683617081/klook-logo-white.png"
            alt="Klook"
            className="h-4 opacity-90"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
            <span className="text-2xl">
              {activity.category === 'adventure' ? '🏔️' : '🏛️'}
            </span>
          </div>

          <div className="flex-1 min-w-0">
            <h4 className="font-semibold text-gray-800 text-sm line-clamp-1">
              {activity.title}
            </h4>
            <p className="text-xs text-gray-500 mt-0.5">
              Find tickets, tours & experiences
            </p>

            <div className="flex items-center gap-3 mt-2">
              <span className="inline-flex items-center gap-1 text-xs text-green-600">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                Best prices
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-green-600">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                Instant confirmation
              </span>
            </div>
          </div>
        </div>

        <a
          href={klookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`
            mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5
            bg-orange-500 hover:bg-orange-600 text-white font-medium text-sm
            rounded-lg transition-all duration-200
            ${isHovered ? 'shadow-lg shadow-orange-200' : ''}
          `}
        >
          <span>Search on Klook</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>

        <p className="text-center text-[10px] text-gray-400 mt-2">
          Powered by Klook • Free cancellation on select activities
        </p>
      </div>
    </div>
  );
};

export const KlookBookingButton = ({ activity, cities = [], destination }) => {
  if (!activity || !['sightseeing', 'adventure'].includes(activity.category)) {
    return null;
  }

  const resolvedCities = cities.length
    ? cities
    : destination ? [destination.split(',')[0].trim()] : [];
  const klookUrl = getKlookSearchUrl(activity.title, resolvedCities);

  return (
    <a
      href={klookUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium rounded-full transition-colors"
    >
      <span>🎫</span>
      <span>Book on Klook</span>
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
      </svg>
    </a>
  );
};

export default KlookBookingCard;
